import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {ThemeGrid} from '@Components/ai-chat-window/components/change-style-dropdown/components/theme-grid/theme-grid';
import type {ChangeStylePopupProps} from './change-style-popup.types';

export function ChangeStylePopup({onThemeSelect}: ChangeStylePopupProps): ReactElement {
  return (
    <div className="flex-v-row gap-3">
      <Text val={window.i18next.t('pmwjs_ai_chat_change_style_heading')} size={TextSize.MD} bold />
      <ThemeGrid onThemeSelect={onThemeSelect} />
    </div>
  );
}
